<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="5" lg="3">
            <material-card color="nav">
              <p class="headline primary--text">Entrar</p>
              <v-form ref="form" lazy-validation>
                <v-col cols="12">
                  <v-text-field
                    autofocus
                    :rules="requiredRule"
                    id="user"
                    ref="user"
                    label="Usuário"
                    v-model="auth.usuario"
                    name="login"
                    prepend-icon="mdi-account-key"
                    type="text"
                    lazy
                  ></v-text-field>
                  <password-field
                    :rules="requiredRule"
                    id="password"
                    v-model="auth.senha"
                    label="Senha"
                    name="password"
                    prepend-icon="mdi-lock"
                    lazy
                  />
                </v-col>
                <v-col cols="12" class="text-center">
                  <v-btn block @click="submit()" color="primary">Acessar</v-btn>
                </v-col>
                <v-col cols="12" class="text-right" color="info">
                  <a
                    @click="goToForgotPassword()"
                    class="primary--text"
                  >{{ $vuetify.lang.t("$vuetify.login.forgotPassword")}}</a>
                </v-col>
              </v-form>
            </material-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapMutations } from "vuex";
import rules from "@/utils/rules";
import PasswordField from "@/components/shared/PasswordField";
//import { Encrypt } from '@/utils/encrypt';

export default {
  components: {
    PasswordField
  },
  mixins: [rules],
  data() {
    return {
      auth: {
        usuario: "",
        senha: ""
      }
    };
  },
  mounted() {
    let usuario = localStorage.getItem("userCredential");
    if (usuario) this.auth.usuario = usuario;
  },
  methods: {
    ...mapActions("auth", ["autenticar"]),
    ...mapMutations("auth", ["setCredentials"]),
    ...mapMutations("app", ["setDrawer"]),
    goToForgotPassword() {
      this.$router.push({ name: "EsqueceuSenha" });
    },
    submit() {
      if (this.$refs.form.validate()) {
        this.autenticar({usuario: this.auth.usuario, senha: this.auth.senha }).then(data => {
          this.setCredentials(data);
          this.setDrawer(true);
          this.$router.push({ name: "Dashboard" });
          localStorage.setItem("userCredential", this.auth.usuario);
        });
      }
    }
  }
};
</script>
